import Checkbox from 'components/CheckBox';
import SelectDropdown from 'components/SelectDropdown';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { OfferType, OfferEligibilityType } from 'legacy/events/types';
import { v4 as uuid } from 'uuid';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import UserSelectionModal from './components/UserSelectionModal';
import { UserLean } from 'legacy/user/types';
import UserSelection from './components/UserSelection';

const OfferEligibilitySelection = () => {
  const { values, setFieldValue } = useFormikContext<OfferType>();
  const offerEligibility = values.eligibilityCriteria;
  const [userSelectionModal, setUserSelectionModal] = useState({
    id: '',
    show: false
  });

  const handleUserSelectionModalClose = () => {
    setUserSelectionModal({
      id: '',
      show: false
    });
  };

  const handleUserSelectionModalSubmit = (users: UserLean[]) => {
    const newUserSelection = [...offerEligibility];
    const index = newUserSelection.findIndex(
      (userSelection) => userSelection.id === userSelectionModal.id
    );
    newUserSelection[index].users = users;
    setFieldValue('eligibilityCriteria', newUserSelection);
    handleUserSelectionModalClose();
  };

  const handleMustHaveTicketChange = (id: string) => {
    const newUserSelection = [...offerEligibility];
    const index = newUserSelection.findIndex(
      (userSelection) => userSelection.id === id
    );
    newUserSelection[index].mustHaveTicket =
      !newUserSelection[index].mustHaveTicket;
    setFieldValue('eligibilityCriteria', newUserSelection);
  };

  const handleRemoveEligibility = (id: string) => {
    const newUserSelection = [...offerEligibility];
    const index = newUserSelection.findIndex(
      (userSelection) => userSelection.id === id
    );
    newUserSelection.splice(index, 1);
    setFieldValue('eligibilityCriteria', newUserSelection);
  };

  const handleEligibilityChange = (
    id: string,
    selector: OfferEligibilityType
  ) => {
    const newUserSelection = [...offerEligibility];
    const index = newUserSelection.findIndex(
      (userSelection) => userSelection.id === id
    );
    newUserSelection[index].selector = selector;
    setFieldValue('eligibilityCriteria', newUserSelection);
  };

  return (
    <>
      <div className="flex flex-col mt-10">
        <div className="text-base font-bold text-[#202020]">
          Who is eligible to claim this offer
        </div>
        {offerEligibility.map((eligibility, index) => (
          // const hasAllOptionSelected = offerEligibility.some(eligibility => eligibility.selector === OfferEligibilityType.ALL);
          // const hideAllOption = offerEligibility.length > 1 && hasAllOptionSelected;
          <FadeIn key={eligibility.id}>
            <div className="mt-4">
              <SelectDropdown
                onChange={(value) => {
                  handleEligibilityChange(
                    eligibility.id,
                    value as OfferEligibilityType
                  );
                }}
                value={eligibility.selector}
                textValueStyle={dropdownStyle}
                controlStyle={controlStyle}
                data={[
                  // ...(hideAllOption ? [] : [{
                  //   value: OfferEligibilityType.ALL,
                  //   label: 'Any Bounce User'
                  // }]),
                  {
                    value: OfferEligibilityType.USERS,
                    label: 'Individual Bounce User'
                  }
                ]}
              />
              {eligibility.selector === OfferEligibilityType.USERS && (
                <UserSelection
                  eligibility={eligibility}
                  setUserSelectionModal={setUserSelectionModal}
                  index={index}
                />
              )}
              <div className="flex flex-row mt-2 justify-between">
                <div className="text-sm font-bold text-[#575757]">
                  Must have ticket
                </div>
                <Checkbox
                  checked={eligibility.mustHaveTicket}
                  onChange={() => handleMustHaveTicketChange(eligibility.id)}
                />
              </div>
              {offerEligibility?.length === 1 && (
                <div className="w-full border-b-1 border-gray-200 py-2" />
              )}
              {offerEligibility?.length > 1 && (
                <div className="mt-4 flex items-center">
                  <div className="w-full border-b-1 border-gray-200" />
                  <button
                    type="button"
                    className="pl-4 text-red-700 text-sm"
                    onClick={() => handleRemoveEligibility(eligibility.id)}
                  >
                    Remove
                  </button>
                </div>
              )}
              <button
                type="button"
                className="mt-3 text-[#3853C4] font-bold text-sm"
                onClick={() => {
                  setFieldValue('eligibilityCriteria', [
                    ...offerEligibility,
                    {
                      id: uuid(),
                      selector: OfferEligibilityType.USERS,
                      mustHaveTicket: false,
                      users: []
                    }
                  ]);
                }}
              >
                + Add more users
              </button>
            </div>
          </FadeIn>
        ))}
        {userSelectionModal.show && (
          <UserSelectionModal
            users={
              offerEligibility.find(
                (eligibility) => eligibility.id === userSelectionModal.id
              )?.users || []
            }
            onClose={handleUserSelectionModalClose}
            onSubmit={handleUserSelectionModalSubmit}
          />
        )}
      </div>
    </>
  );
};

const dropdownStyle = {
  color: '#202020',
  fontWeight: 400,
  fontSize: 14
};

const controlStyle = {
  borderColor: '#DCDCDC'
};

export default OfferEligibilitySelection;
